import { useEffect, useState } from "react";
import api from "../api/axios";
import { toast } from "react-toastify";

export default function useFetch(url, options = {}) {
  const {
    initialData = [],
    autoFetch = true,
    onSuccess,
    onError,
  } = options;

  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(autoFetch);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(url);
      setData(res.data);
      onSuccess?.(res.data);
    } catch (err) {
      setError(err);
      onError?.(err);
      toast.error("Error al cargar datos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) fetchData();
  }, [url]);

  return { data, loading, error, refetch: fetchData };
}
